import * as React from "react";
import type { SVGProps } from "react";

interface EndOfLapProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const EndOfLap = ({ cancelled = false, ...props }: EndOfLapProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M21.625 9.019c.806 1.703 1.272 3.38 1.242 4.765-.047 2.139-1.343 3.716-3.567 3.716-1.275 0-2.374-.21-3.825-.637-.886-.26-1.345-.387-1.567-.45l-.027-.007-.026.083c-.097.316-.18.78-.24 1.4l-.021.24c-.35 4.283-3.897 5.64-7.607 4.141-3.264-1.319-5.742-4.319-4.918-7.248 1.102-3.92 8.534-9.994 13.008-11.78 2.802-1.118 5.658 1.781 7.548 5.777m-6.342-2.056-.199.09c-3.545 1.624-9.59 6.639-10.26 9.025-.154.544.973 1.91 2.624 2.576 1.548.626 2.158.393 2.258-.84.229-2.807.924-4.453 2.63-5.103.754-.288 1.51-.284 2.391-.102.286.06.579.136.948.244.165.048.77.23.9.268.9.265 1.574.413 2.232.461l.16.008-.001-.044c-.027-.637-.291-1.582-.748-2.603l-.118-.256c-.582-1.23-1.356-2.387-2.088-3.13-.273-.278-.519-.475-.705-.582z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M14.355 3.938c2.255-.9 4.864 1.75 6.592 5.401.76 1.608 1.197 3.178 1.17 4.429-.038 1.762-1.04 2.982-2.817 2.982-1.19 0-2.225-.198-3.614-.607-1.765-.519-2.015-.57-2.228-.49-.206.08-.473.713-.612 2.416-.3 3.696-3.284 4.836-6.578 3.506-2.954-1.194-5.172-3.88-4.477-6.35 1.025-3.645 8.285-9.579 12.564-11.287m4.423 6.428c-1.207-2.55-3.028-4.4-3.533-4.198C11.59 7.626 4.878 13.112 4.1 15.875c-.282 1.003 1.105 2.682 3.066 3.474 1.964.794 3.139.345 3.287-1.475.207-2.544.8-3.948 2.149-4.463.98-.374 1.142-.34 3.76.43 1.188.35 2.024.51 2.937.51.342 0 .405-.078.417-.635.018-.818-.324-2.05-.94-3.35"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="m10.27 2.899.085.096.08.097.078.1 3.527 4.855a3.05 3.05 0 0 1-.675 4.26l-1.618 1.175a3.05 3.05 0 0 1-4.26-.674L3.96 7.953a3.05 3.05 0 0 1 .675-4.26l1.618-1.175a3.05 3.05 0 0 1 4.018.38"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="m9.777 3.473.08.097.05.063 3.526 4.854a2.3 2.3 0 0 1-.509 3.213l-1.618 1.176a2.3 2.3 0 0 1-3.212-.51L4.567 7.514A2.3 2.3 0 0 1 5.076 4.3l1.618-1.176c.94-.683 2.24-.555 3.083.349"
      />
      <path
        fill="#60B100"
        d="m8.855 4.397 3.526 4.854a1 1 0 0 1-.22 1.397l-1.619 1.176a1 1 0 0 1-1.397-.221L5.62 6.749a1 1 0 0 1 .22-1.397l1.619-1.176a1 1 0 0 1 1.317.124z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default EndOfLap;
